import { render } from "./carChildrenPrivacy.vue?vue&type=template&id=06dfe96a"
const script = {}

import "./carChildrenPrivacy.vue?vue&type=style&index=0&id=06dfe96a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__